import { MERCHANT } from "constants/action-types";
import { ActionsObservable } from "redux-observable";
import { ajax } from "lib/observable";
import siteConfig from "site-config";
import {
    IUpdateSetupStepRequest,
    SetupStepStatus,
    SetupType,
} from "containers/admin/settings/merchant-admin-settings/setup-guide/types";
import { Observable } from "rxjs";
import { formatMessage } from "lib/globalize-util";
import {
    GetMerchantSetupStepsRequestAction,
    getMerchantSetupStepsComplete,
    PutMerchantSetupStepsRequestAction,
    putMerchantSetupStepsComplete,
} from "actions/merchant/merchant-setup-steps";

export const getMerchantSetupStepEpic = (action$: ActionsObservable<GetMerchantSetupStepsRequestAction>) =>
    action$
        .ofType(MERCHANT.SETUP_STEPS.GET.REQUEST)
        .map(({ payload }) => payload)
        .switchMap(({ merchantId }) => {
            return ajax({
                method: "GET",
                url: `${siteConfig.api}/setup/${SetupType.MerchantSetupGuide}/?referenceId=${merchantId}`,
            })
                .flatMap(({ response, status }) => {
                    if (status !== 200) {
                        throw new Error(response || formatMessage("Unknown get error"));
                    }

                    return [getMerchantSetupStepsComplete(response)];
                })
                .catch((error) => Observable.merge(Observable.of(getMerchantSetupStepsComplete(error))));
        });

export const putMerchantSetupStepEpic = (action$: ActionsObservable<PutMerchantSetupStepsRequestAction>) =>
    action$
        .ofType(MERCHANT.SETUP_STEPS.PUT.REQUEST)
        .map(({ payload }) => payload)
        .switchMap(({ name, merchantId }) => {
            return ajax({
                method: "PUT",
                url: `${siteConfig.api}/setup/${SetupType.MerchantSetupGuide}/?referenceId=${merchantId}`,
                body: {
                    name: name,
                    status: SetupStepStatus.COMPLETE,
                } as IUpdateSetupStepRequest,
            })
                .flatMap(({ response, status }) => {
                    if (status !== 200) {
                        throw new Error(response || formatMessage("Unknown get error"));
                    }

                    return [putMerchantSetupStepsComplete(response)];
                })
                .catch((error) => Observable.merge(Observable.of(putMerchantSetupStepsComplete(error))));
        });
